<template>
  <div class="edit-article-wrapper">
    <div class="edit-title flex" @click="switchEdit">
      <span class="edit-text">写文章</span>
      <el-button v-show="editing" class="handlian-btn" @click="resetEditor"
        >取消编辑</el-button
      >
      <span class="edit-icon" title="写文章"></span>
    </div>
    <div class="edit-body" v-show="showEditArea" v-loading="loadArticle">
      <el-form
        :model="editArticleForm"
        :rules="rules"
        :disabled="forbitEdit"
        ref="editArticleForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item prop="articleTitle">
          <el-input
            v-model="editArticleForm.articleTitle"
            placeholder="输入文章标题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="articleContent">
          <el-input
            type="textarea"
            v-model="editArticleForm.articleContent"
            resize="none"
            :autosize="{ minRows: 2 }"
            placeholder="输入文章内容"
          ></el-input>
        </el-form-item>
        <el-form-item prop="artileTag">
          <el-select
            v-model="editArticleForm.artileTag"
            placeholder="选择文章标签"
            style="width: 130px"
          >
            <el-option
              v-for="(item, index) in articleTags"
              :key="index"
              :label="item.name"
              :value="item.tagId"
            ></el-option>
          </el-select>
          <el-checkbox
            v-if="!editing"
            class="original-picture"
            v-model="originalPic"
            :disabled="forbitEdit"
            >原图上传</el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-upload
            class="cl-upload-control"
            ref="upload"
            :limit="9"
            :multiple="true"
            accept="image/*"
            action="api/image/upload"
            :disabled="forbitUpload"
            :on-change="fileListChange"
            :before-upload="beforeUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-exceed="exceedLimit"
            list-type="picture-card"
            :auto-upload="false"
          >
            <i class="el-icon-plus" title="选择图片"></i>
            <div slot="tip" class="el-upload__tip">{{ uploaderTipText }}</div>
          </el-upload>
          <el-dialog :visible.sync="previewVisible">
            <img width="100%" :src="previewImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <div class="edit-bar">
            <el-button
              class="handlian-btn"
              :disabled="forbitSave"
              type="primary"
              @click="submitForm('editArticleForm')"
              >上传</el-button
            >
            <el-button
              class="handlian-btn"
              @click="resetForm('editArticleForm')"
              >重置</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="shareVisible"
      width="30%"
      :close-on-click-modal="false"
      custom-class="handlian-share-article"
      :before-close="clearShareForm"
    >
      <span class="share-tip"
        >上传成功，您还可以分享新文章，不分享就点“取消”。</span
      >
      <el-form
        :model="shareArticleForm"
        :rules="shareRules"
        ref="shareArticleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="分享区域" prop="shareArea">
          <el-checkbox-group v-model="shareArticleForm.shareArea">
            <el-checkbox label="shareFriends" name="shareArea"
              >小区</el-checkbox
            >
            <el-checkbox label="sharePublic" name="shareArea">社区</el-checkbox>
            <el-checkbox label="shareFamily" name="shareArea">族窗</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="handlian-btn" @click="clearShareForm"
          >取 消</el-button
        >
        <el-button
          class="handlian-btn"
          type="primary"
          @click="submitShareForm('shareArticleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import { newFileName, htmlFilter } from "../../utils/feed";
import Compressor from "compressorjs";
import qs from "qs";
export default {
  name: "edit-article",
  props: {
    editScene: String,
  },
  data() {
    return {
      editing: false,
      showEditArea: false,
      resetForbit: false,
      previewVisible: false,
      shareVisible: false,
      loadArticle: false,
      onInitImage: true, //阻止重复提交表单
      newArticleID: "",
      oldArticleID: "",
      previewImageUrl: "",
      editArticleForm: {
        articleTitle: "",
        artileTag: "",
        articleContent: "",
      },
      originalPic: false,
      uploaderTipText: "最多可选择 9 张图片",
      shareArticleForm: {
        shareArea: [],
      },
      rules: {
        articleTitle: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        artileTag: [
          { required: true, message: "请选择文章标签", trigger: "change" },
        ],
        articleContent: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
      },
      shareRules: {
        shareArea: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个分享区域",
            trigger: "change",
          },
        ],
      },
      fileList: [],
      imageList: [],
      successFiles: [],
      doneFile: [],
      fileCount: 0,
      failFiles: [],
      articleTags: [],
      forbitUpload: false,
      forbitEdit: false,
      forbitSave: false,
    };
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  mounted() {
    this.$bus.$on("edit-article", this.initEditArticle);
  },
  methods: {
    switchEdit() {
      if (this.showEditArea == false) {
        this.showEditArea = true;
        if (this.articleTags.length == 0) {
          this.getArticleTag((res) => {
            this.articleTags = res;
          });
        }
        this.initUserPermission();
      } else {
        this.showEditArea = false;
      }
    },
    canReset() {
      this.resetForbit = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editing) {
            this.saveOldArticle(this.$refs[formName].model);
          } else {
            let awaitFiles = this.imageList;
            let articleImgKey = "";
            let fileKb = "1";
            if (awaitFiles.length == 0) {
              this.publishArticle(
                this.$refs[formName].model,
                articleImgKey,
                fileKb
              );
            } else {
              this.fileCount = awaitFiles.length;
              if (this.originalPic) {
                this.inOrderUpload(0); //按顺序原图上传
              } else {
                this.afterReadCompress(0); //按顺序压缩上传
              }
              // this.submitUpload();多文件同时上传
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
      this.forbitUpload = false;
      this.forbitSave = false;
      this.editing = false;
      this.forbitEdit = false;
      this.fileList = [];
      this.imageList = [];
      this.successFiles = [];
      this.failFiles = [];
      this.doneFile = [];
      this.onInitImage = true;
      this.originalPic = false;
      this.fileCount = 0;
      this.oldArticleID = "";
      this.uploaderTipText = "最多可选择 9 张图片";
    },
    submitUpload() {
      console.log(this.$refs.upload);
      this.forbitUpload = true;
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      // 删除本地
      this.imageList = fileList;
      // console.log('要删除的文件：',file)
      // var findIndex = -1;
      // this.imageList.filter((item,index)=>{
      //     if (item.uid == file.uid) {
      //         findIndex = index
      //     }
      // });
      // if (findIndex!=-1) {
      //     console.log(findIndex)
      //     this.imageList.splice(findIndex,1);
      //     console.log('删除后文件列表',this.imageList)
      // }
    },
    fileListChange(file, fileList) {
      let img_regexp = /^image\/\w/g;
      if (!img_regexp.test(file.raw.type)) {
        this.$message({
          message: "请选择图片文件",
          duration: 1500,
          offset: 230,
        });
        return false;
      }
      this.imageList = fileList;
      // console.log('要添加的文件',file);
      // console.log('添加前文件列表',this.imageList)
      // let findImage = this.imageList.filter(item=>item.uid==file.uid);
      // if (findImage.length==0) {
      //     this.imageList.push(file)
      // }
      // console.log('添加后文件列表',this.imageList)
    },
    handlePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    afterReadCompress(index) {
      let _this = this;
      let currentFile = _this.imageList[index];
      if (currentFile && currentFile.raw) {
        var file = currentFile.raw;
        new Compressor(file, {
          quality: 0.6,
          success(result) {
            var newFile = new File([result], newFileName(result.name));
            var formData = new FormData();
            formData.append("file", newFile);
            _this
              .$axios({
                baseURL: apiMap["uploadUrl"],
                method: apiMap["uploadFile"]["method"],
                url: apiMap["uploadFile"]["url"],
                data: formData,
                timeout: 6000,
              })
              .then(function(response) {
                if (response.data.code == 200) {
                  currentFile.status = "success";
                  _this.successFiles.push(newFile);
                  let curFile = {
                    name: response.data.fileName,
                    url: response.data.file,
                    size: newFile.size,
                  };
                  _this.doneFile.push(curFile);
                } else {
                  currentFile.status = "failed";
                  _this.failFiles.push(newFile);
                }

                if (index < _this.imageList.length) {
                  index++;
                  _this.afterReadCompress(index);
                }

                if (
                  _this.successFiles.length + _this.failFiles.length ==
                  _this.fileCount
                ) {
                  _this.initArticleImage();
                }
              })
              .catch(function(error) {
                console.log(error);
                if (error.message.includes("timeout")) {
                  _this.$dialogue
                    .alert({
                      message: "文件上传超时",
                      confirmButtonColor: "#1a70db",
                    })
                    .then(() => {});
                } else {
                  _this.$message({
                    message: "文件上传出错",
                    type: "warning",
                    offset: 50,
                  });
                }
                _this.initArticleImage();
              });
          },
          error(err) {
            _this.fileCount -= 1;
          },
        });
      }
    },
    inOrderUpload(index) {
      let _this = this;
      let currentFile = _this.imageList[index];
      if (currentFile && currentFile.raw) {
        var file = currentFile.raw;
        var newFile = new File([file], newFileName(file.name));
        var formData = new FormData();
        formData.append("file", newFile);
        _this
          .$axios({
            baseURL: apiMap["uploadUrl"],
            method: apiMap["uploadFile"]["method"],
            url: apiMap["uploadFile"]["url"],
            data: formData,
            timeout: 6000,
          })
          .then(function(response) {
            if (response.data.code == 200) {
              currentFile.status = "success";
              _this.successFiles.push(newFile);
              let curFile = {
                name: response.data.fileName,
                url: response.data.file,
                size: newFile.size,
              };
              _this.doneFile.push(curFile);
            } else {
              currentFile.status = "failed";
              _this.failFiles.push(newFile);
            }

            if (index < _this.imageList.length) {
              index++;
              _this.inOrderUpload(index);
            }

            if (
              _this.successFiles.length + _this.failFiles.length ==
              _this.fileCount
            ) {
              _this.initArticleImage();
            }
          })
          .catch(function(error) {
            console.log(error);
            if (error.message.includes("timeout")) {
              _this.$alert("文件上传超时", {
                confirmButtonText: "确定",
                showClose: false,
              });
            } else {
              _this.$message({
                message: "文件上传出错",
                type: "warning",
                duration: 1500,
                offset: 230,
              });
            }
            _this.initArticleImage();
          });
      }
    },
    beforeUpload(file) {
      var newFile = new File([file], newFileName(file.name));
      var formData = new FormData();
      formData.append("file", newFile);
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["uploadUrl"],
          method: apiMap["uploadFile"]["method"],
          url: apiMap["uploadFile"]["url"],
          data: formData,
          timeout: 5000,
        })
        .then(function(response) {
          if (response.data.code == 200) {
            $this.successFiles.push(newFile);
            let curFile = {
              name: response.data.fileName,
              url: response.data.file,
              size: newFile.size,
            };
            $this.doneFile.push(curFile);
          } else {
            $this.failFiles.push(newFile);
          }

          var myInterval = setInterval(function() {
            let successFiles = $this.successFiles;
            let failFiles = $this.failFiles;
            if (successFiles.length + failFiles.length == $this.fileCount) {
              clearInterval(myInterval);
              if ($this.onInitImage) {
                $this.initArticleImage();
              }
            }
          }, 1000);
          setTimeout(() => {
            clearInterval(myInterval);
          }, 5 * 60 * 1000);
        })
        .catch(function(error) {
          console.log(error);
          if (error.message.includes("timeout")) {
            $this.$alert("文件上传超时", {
              confirmButtonText: "确定",
              showClose: false,
            });
          } else {
            $this.$message({
              message: "文件上传出错",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        });
      return false;
    },
    exceedLimit(file, fileList) {
      this.$message({
        message: "最多可选择9张图片哦",
        duration: 1500,
        offset: 230,
      });
    },
    getArticleTag(cb) {
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["articleTag"]["method"],
        url: apiMap["articleTag"]["url"],
      })
        .then(function(response) {
          cb(response.data.result.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initArticleImage() {
      let uploadFiles = this.doneFile;
      var tempKey = [];
      var tempSize = 0;
      for (let index = 0; index < uploadFiles.length; index++) {
        tempKey.push(uploadFiles[index].url);
        tempSize += uploadFiles[index].size;
      }
      if (tempKey.length != 0 && tempSize != 0) {
        this.onInitImage = false;
        tempSize = (tempSize / 1024).toFixed(2);
        this.publishArticle(
          this.$refs["editArticleForm"].model,
          tempKey.join(","),
          tempSize
        );
      }
    },
    publishArticle(formData, picture, fileSize) {
      let _this = this;
      _this.forbitEdit = true;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      // var params = '';
      // if (picture!='') {
      //     params = `token=${loginUser.token}&tagId=${formData.artileTag}&title=${formData.articleTitle}&content=${formData.articleContent}&image=${picture}&storage=${fileSize}`
      // }else {
      //     params = `token=${loginUser.token}&tagId=${formData.artileTag}&title=${formData.articleTitle}&content=${formData.articleContent}&storage=${fileSize}`
      // }
      var submitData = {
        token: loginUser.token,
        tagId: formData.artileTag,
        title: formData.articleTitle,
        content: encodeURIComponent(formData.articleContent),
        storage: fileSize,
      };
      if (picture != "") {
        submitData.image = picture;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["uploadArticle"]["method"],
          url: apiMap["uploadArticle"]["url"],
          transformRequest: [
            function(data, headers) {
              return data;
            },
          ],
          data: qs.stringify(submitData, { encode: false }),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.resetForm("editArticleForm");
            _this.newArticleID = response.data.result.data;
            _this.shareVisible = true;
            //用户文章列表页 刷新文章列表
            if (_this.editScene == "userArticle") {
              _this.$bus.$emit("reload-article-list");
            }
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
            this.$refs.upload.clearFiles();
            this.fileCount = 0;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    submitShareForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(_this.$refs[formName].model);

          let shareArea = _this.$refs[formName].model.shareArea;
          if (shareArea.length == 1) {
            _this.shareNewArticle(shareArea[0], 1);
          } else if (shareArea.length > 0) {
            for (let index = 0; index < shareArea.length; index++) {
              const element = shareArea[index];
              _this.shareNewArticle(element, index);
            }
          }
          _this.$alert("审核通过后立即发布", "内容审核中", {
            confirmButtonText: "知道了",
            callback: (action) => {},
          });
          _this.clearShareForm();
        } else {
          return false;
        }
      });
    },
    initShare() {
      this.shareVisible = false;
      if (this.shareResult.length != 0) {
        this.shareResult.forEach((element) => {
          this.shareNewFeed(element);
        });
        this.$dialogue
          .alert({
            title: "内容审核中",
            message: "审核通过后立即发布",
            confirmButtonText: "知道了",
            confirmButtonColor: "#1a70db",
          })
          .then(() => {
            this.onClickLeft();
          });
      }
    },
    clearShareForm() {
      this.$refs["shareArticleForm"].resetFields();
      this.shareVisible = false;
    },
    shareNewArticle(shareArea, type) {
      let _this = this;
      if (_this.newArticleID == "") {
        return false;
      }
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&articleId=${_this.newArticleID}&shareField=${shareArea}&shareValue=1`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["articleShare"]["method"],
          url: apiMap["articleShare"]["url"],
          data: params,
        })
        .then(function(response) {
          // let tips = "";
          // switch (shareArea) {
          //   case "shareFriends":
          //     tips = "到小区";
          //     break;
          //   case "sharePublic":
          //     tips = "到社区";
          //     break;
          // }
          if (response.data.result.statusCode == 1) {
            // let msg = `分享${tips}成功！`;
            // _this.$message({
            //   message: msg,
            //   type: "success",
            //   duration: 1500,
            //   offset: 230,
            // });
            if (
              shareArea == "shareFriends" &&
              _this.editScene == "friendFeed"
            ) {
              _this.$bus.$emit("update-feed-list");
            } else {
              _this.$bus.$emit("reload-article-list");
            }
          } else {
            // let msg = `分享${tips}失败，稍后再试`;
            // _this.$message({
            //   message: msg,
            //   type: "warning",
            //   duration: 1500,
            //   offset: 230,
            // });
          }
          // if (type == 1) {
          //   _this.newArticleID = "";
          // }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initEditArticle(articleID) {
      this.showEditArea = true;
      if (this.articleTags.length == 0) {
        this.getArticleTag((res) => {
          this.articleTags = res;
        });
      }
      this.uploaderTipText = "重新编辑文章时，不能选择图片";
      this.forbitUpload = true;
      this.loadArticle = true;
      document.documentElement.scrollTop = 0;
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: articleID,
            modelType: 1,
            self: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.loadArticle = false;
            _this.editing = true;
            _this.oldArticleID = response.data.result.data.modelId;
            _this.editArticleForm.articleTitle = htmlFilter(
              response.data.result.data.title
            );
            _this.editArticleForm.artileTag = response.data.result.data.tagId;
            _this.editArticleForm.articleContent = htmlFilter(
              response.data.result.data.content
            );
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    resetEditor() {
      this.showEditArea = false;
      this.resetForm("editArticleForm");
    },
    saveOldArticle(formData) {
      let _this = this;
      if (_this.oldArticleID == "") {
        return false;
      }
      _this.forbitEdit = true;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let paramArr = [
        `token=${loginUser.token}`,
        `tagId=${formData.artileTag}`,
        `title=${formData.articleTitle}`,
        `content=${encodeURIComponent(formData.articleContent)}`,
        `articleId=${_this.oldArticleID}`,
        `storage=1`,
      ];
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["updateArticle"]["method"],
          url: apiMap["updateArticle"]["url"],
          data: paramArr.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.showEditArea = false;
            _this.resetForm("editArticleForm");
            _this.$message({
              message: "编辑成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-article-list");
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initUserPermission() {
      // console.log(this.userProfile)
      if (this.userProfile.articlePermission == 0) {
        this.$alert("抱歉，您目前没有权限上传文章", {
          confirmButtonText: "确定",
          showClose: false,
        });
        this.forbitEdit = true;
      } else {
        var myTempSpace = parseFloat(
          this.userProfile["tempSpaceSizeMbNum"]
        ).toFixed(2);
        var residueSpace = myTempSpace - this.userProfile["tempUsedSpaceMBNum"];
        if (residueSpace < 0) {
          this.$alert("您的短期空间不足，请在手机端续费或购买", {
            confirmButtonText: "确定",
            showClose: false,
          });
          this.forbitEdit = true;
        }
      }
    },
  },
};
</script>
<style scoped>
.edit-title {
  font-size: 16px;
  line-height: 23px;
  justify-content: space-between;
}

.edit-icon {
  display: inline-block;
  width: 25px;
  height: 23px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/icon/cl_new_article.png");
}

.edit-body {
  min-height: 80px;
  margin: 15px 0 0;
}

.share-tip {
  font-size: 16px;
  color: #00cc00;
}

.cancel-edit-btn {
  margin-right: 15px;
  font-size: 16px;
  cursor: pointer;
}

.original-picture {
  margin-left: 20px;
}
</style>
